var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuilingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.981,
    height: 18.981,
    viewBox: "0 0 18.981 18.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3165",
    d: "M0-682.665H18.981v18.981H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3159",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3163",
    transform: "translate(13 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3169",
    transform: "translate(2.939 2.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3171",
    d: "M-406.119,0h-10.126a1.493,1.493,0,0,0-1.489,1.489v14h13.1v-14A1.493,1.493,0,0,0-406.119,0Z",
    transform: "translate(417.734)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3173",
    transform: "translate(5.321 0.556)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3175",
    d: "M0-83.307V-84.2a1.493,1.493,0,0,1,1.489-1.489H6.85A1.494,1.494,0,0,1,8.339-84.2v.893",
    transform: "translate(0 85.689)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3177",
    transform: "translate(7.108 14.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3179",
    d: "M0-124.959v-2.085a1.493,1.493,0,0,1,1.489-1.489H3.276a1.493,1.493,0,0,1,1.489,1.489v2.085",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3181",
    transform: "translate(9.491 14.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3183",
    d: "M0-124.959v-3.574",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3185",
    transform: "translate(5.917 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3187",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3189",
    transform: "translate(8.299 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3191",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3193",
    transform: "translate(5.917 7.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3195",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3197",
    transform: "translate(8.299 7.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3199",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3201",
    transform: "translate(5.917 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3203",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3205",
    transform: "translate(8.299 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3207",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3209",
    transform: "translate(5.917 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3211",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3213",
    transform: "translate(8.299 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3215",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3217",
    transform: "translate(10.682 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3219",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3221",
    transform: "translate(13.065 5.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3223",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3225",
    transform: "translate(10.682 7.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3227",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3229",
    transform: "translate(13.065 7.704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3231",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3233",
    transform: "translate(10.682 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3235",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3237",
    transform: "translate(13.065 10.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3239",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3241",
    transform: "translate(10.682 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3243",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3245",
    transform: "translate(13.065 12.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3247",
    d: "M0,0H0",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilingIcon);
export default __webpack_public_path__ + "static/media/builing_icon.88df786f3a275311bd5e70d5eac51079.svg";
export { ForwardRef as ReactComponent };